import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState } from "react";
import SEO from "../components/seo";
import Form from "../components/forms/contact/form";
import Layout from "../components/layout";
import FirebaseHandler from "../services/firebase";
import { FormTypes } from "../components/forms/formsTypes";
import { httpsCallable } from "firebase/functions";
import MakroAlert, { MakroAlertType } from "../components/common/alert";
var ContactPage = function ContactPage(_ref) {
    var data = _ref.data;
    var _useState = useState("NONE"), state = _useState[0], setState = _useState[1];
    var _useState2 = useState(false), showErr = _useState2[0], setShowErr = _useState2[1];
    var onSubmit = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) {
            var description, rest, submitForm, res;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setShowErr(false);
                            description = data.description, rest = _objectWithoutPropertiesLoose(data, ["description"]);
                            submitForm = httpsCallable(FirebaseHandler.functions, "submitForm");
                            _context.next = 5;
                            return submitForm(Object.assign({
                                formType: FormTypes.CONTACT_FORM,
                                submissionDate: new Date().toISOString()
                            }, rest));
                        case 5:
                            res = _context.sent;
                            // @ts-ignore
                            if (res.data.status === "success") {
                                setState("SUCCESS");
                            }
                            else {
                                setState("ERROR");
                            }
                        case 7:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function onSubmit(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Kontakt"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Kontakt"), /*#__PURE__*/ React.createElement(Form, {
        onSubmit: onSubmit
    }), state == "ERROR" && /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        text: "Das hat leider nicht geklappt. Bitte versuchen Sie es erneut."
    }), state == "SUCCESS" && /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.SUCCESS,
        text: "Vielen Dank f\xFCr Ihre Nachricht! Wir melden uns schnellstm\xF6glich bei Ihnen."
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-6 pb-8 content-text",
        dangerouslySetInnerHTML: {
            __html: data.datoCmsContact.text
        }
    })))));
};
var query = "3917844267";
export default ContactPage;
